import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface TitleProps {
  title: string;
  titleFontSize?: keyof typeof textVariants;
  className?: string;
}

export const HeaderTitle = memo(function HeaderTitle({
  title,
  titleFontSize = "title2",
  className,
}: TitleProps) {
  return (
    <h2
      className={cn(
        textVariants[titleFontSize],
        "line-clamp-1 flex-1 text-center leading-normal text-black",
        className,
      )}
    >
      {title}
    </h2>
  );
});
